import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    travelMissedConnection: 'false',
    schoolNameForDelay: '',
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    dateTripWasDelayedWithTravelSupplier: '',
    dateDelayEndedForDelay: '',
    detailsRegardingYourTripDelay: '',
    lossInformationItems: [],
  },
  errors: [],
});

const initialTravelInterruptionState = {
  form: {
    travelMissedConnection: 'false',
    schoolNameForDelay: '',
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    dateTripWasDelayedWithTravelSupplier: '',
    dateDelayEndedForDelay: '',
    detailsRegardingYourTripDelay: '',
    lossInformationItems: [],
  },
};

function missedConnectionStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
           .setIn(['form', 'lossInformationItems'], [])
           .mergeDeep(initialTravelInterruptionState);
    default:
      return state;
  }
}

export default missedConnectionStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.MissedConnectionStep/reducer.js